var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export default (function (studentId, input) { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation updatePhoneNumberMutation($input: UpdatePhoneNumberInput!) {\n      updatePhoneNumber(input: $input) {\n        viewerAgent {\n          id\n          phoneNumber\n        }\n      }\n    }\n  "], ["\n    mutation updatePhoneNumberMutation($input: UpdatePhoneNumberInput!) {\n      updatePhoneNumber(input: $input) {\n        viewerAgent {\n          id\n          phoneNumber\n        }\n      }\n    }\n  "]))),
    variables: { input: input },
    optimisticResponse: {
        updatePhoneNumber: {
            __typename: "UpdatePhoneNumberOutput",
            viewerAgent: {
                __typename: "Agent",
                id: studentId,
                phoneNumber: input.phoneNumber,
            },
        },
    },
}); });
var templateObject_1;
